import { WhatsApp20Regular } from "@/common/icons";
import { MessagingDetailsCard } from "@/components/atoms/interactionDetailsCard";
import { acceptWhatsAppConversation, acceptWhatsAppConversationTransfer, rejectWhatsAppConversation, rejectWhatsAppConversationTransfer } from "@/repository/queryFns";
import { InteractionCardBase } from "./InteractionBase";
import { ChannelType } from "@/common/constants/shared";

const whatsAppConfig = {
    icon: <WhatsApp20Regular />,
    detailsCard: MessagingDetailsCard,
    acceptFn: acceptWhatsAppConversation,
    acceptTransferFn: acceptWhatsAppConversationTransfer,
    rejectFn: rejectWhatsAppConversation,
    rejectTransferFn: rejectWhatsAppConversationTransfer,
    messageIntlId: "Interaction.Contents.WhatsAppMessage",
}

export const WhatsAppInteractionCard = () => {
    return (
        <InteractionCardBase channelType={ChannelType.WhatsApp} channelConfig={whatsAppConfig}/>
    );
};